export default {
  bdtx_save_ncbdtx: '/bdtx/choose-ncbdtx/api/save',
  bdtx_remove_ncbdtx: '/bdtx/choose-ncbdtx/api/remove',
  get_list_ncbdtx_modules:
    '/bdtx/choose-ncbdtx/api/get-list-modules-for-ncbdtx',
};
